module.exports = __webpack_public_path__ + "static/media/lock-white-small.ee9aca5d.svg";